import React from 'react';
import {inject, observer} from 'mobx-react';

import E8TopLogo from './E8TopLogo';
import E8TopMenu from './E8TopMenu';
import E8FreqUseMenu from './E8FreqUseMenu';
import E8QuickSearch from './E8QuickSearch';
import E8HeaderRight from './E8HeaderRight';

@inject('portalThemeStore')
@observer
class E8Header extends React.Component {
    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo} = portalThemeStore;
        const {themeData = {}} = themeInfo;
        const {topcolor} = themeData;

        return (
            <div className="e8header-container">
                <div className="e8header-left">
                    <E8TopLogo {...this.props} />
                </div>
                <div className="e8header-right" style={topcolor ? {backgroundColor: topcolor} : {}}>
                    <div className="e8header-right-menu">
                        <E8TopMenu {...this.props} />
                        <E8FreqUseMenu {...this.props} />
                        <E8QuickSearch {...this.props} />
                    </div>
                    <E8HeaderRight {...this.props} />
                </div>
            </div>
        );
    }
}

export default E8Header;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8Header.js